module.exports = __webpack_public_path__ + "media/images/lb/968-9fef788eb7e9f2fb55ce48352792c3ea.svg";